import { render, staticRenderFns } from "./xx.vue?vue&type=template&id=38a730e1&scoped=true"
import script from "./xx.vue?vue&type=script&lang=js"
export * from "./xx.vue?vue&type=script&lang=js"
import style0 from "./xx.vue?vue&type=style&index=0&id=38a730e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a730e1",
  null
  
)

export default component.exports